import type { AchievementTemplate } from '@engage/achievement-template';
import type { MovementTrackerData } from '../../api-v2-models/generated/MovementTrackerData';
import type { MuscleGroupScoreResponse } from '../../api-v2-models/generated/MuscleGroupScoreResponse';
import type { Ride } from '../../api-v2-models/generated/Ride';
import type { Workout } from '../../api-v2-models/generated/Workout';
import { getWorkout } from '../generated';
import type { AxiosPromise } from '../generated/core/request';

export const workoutDetailsWithMuscleGroupScore = (
  ...args: any[]
): AxiosPromise<
  Workout & {
    achievementTemplates: AchievementTemplate[];
    ride: Ride & {
      muscleGroupScore?: MuscleGroupScoreResponse;
    };
    movementTrackerData?: MovementTrackerData;
    movementTrackerTier: string;
  }
> => getWorkout.apply(this, args);
